import React from 'react';
import { Direction } from '@prisjakt/ui';
import { Dropdown, DropdownContent } from '@prisjakt/ui/dropdown';
import { Behavior } from '@prisjakt/ui/text';
import { zindex } from 'src/ui/zindex';
import { SizeVariantsButtonLabel } from './size-variants-button-label';
import { SizeVariantsGrid } from './size-variants-grid';
import { IVariantsProps } from '../types';
import { DropdownToggle, DropdownButtonText } from './styles';

export const SizeVariantsDesktopVersion: React.FC<IVariantsProps> = props => {
  return (
    <Dropdown zIndex={zindex.overlay}>
      <DropdownToggle showActiveIcon fullWidth>
        <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
          <SizeVariantsButtonLabel />
        </DropdownButtonText>
      </DropdownToggle>
      <DropdownContent alignment={Direction.Down}>
        <SizeVariantsGrid {...props} />
      </DropdownContent>
    </Dropdown>
  );
};
